export default __webpack_public_path__ + "static/media/kitchen3-afterA-480w.d80cbfec.webp";